import BAboutQuestions from './BAboutQuestions'

export default BAboutQuestions
